import imageLogoSD from "../assets/logo.webp";
import imageLogoSP from "../assets/logo.png";

export default process.env.REACT_APP_SITE === "sp" ? imageLogoSP : imageLogoSD;
